export class RouteConstants{

    static readonly HOME:                string = 'home';
    /* SALES */
    static readonly SALES:               string = 'sales';
    static readonly SALES_REPORTS:       string = 'sales-reports';
    static readonly NEW_SALE:            string = 'new-sale';
    
    /* DOCUMENTS */
    static readonly DOCUMENTS:           string = 'documents';
    static readonly NEW_DOCUMENT:        string = 'new-document';

    static readonly ADMIN:               string = 'admins';
    static readonly READER:              string = 'readers';
    static readonly READER_CHILD:        string = 'readers-child';
    static readonly CONTRIBUTOR:         string = 'contributors';
    static readonly LOGINHINT_PARAM:     string = 'user-to-authenticate';
}